import { LottieIcon } from '../LottieIcon'

export function Halloween2025tag() {
  return (
    <LottieIcon
      src="/Lottie/Halloween2025tag.json"
      width={30}
      height={30}
      autoplay
      loop={false}
    />
  )
}
